export interface InstantConfigSamplingCache {
	/**
	 * Floating point from 0 to 100.
	 * @default null
	 * @example 50.75
	 */
	sampling?: number;

	/**
	 * @default false
	 * @example true
	 */
	samplingCache?: boolean;
}
